/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber1Small = createReactComponent("number-1-small", "IconNumber1Small", [
  ["path", { d: "M10 10l2 -2v8", key: "svg-0" }]
]);

export { IconNumber1Small as default };
//# sourceMappingURL=IconNumber1Small.js.map
